import React, { memo } from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { IconOrientation } from 'constants/coreDesignSystem';

import { defaultSize, orientationEnum, sizePropsTypes } from './icons.constants';

const LeftRightExpandedIcon = ({
  size = defaultSize,
  orientation = IconOrientation.ANGLE,
  className,
  ...props
}) => (
  <svg
    className={clsx(orientationEnum[orientation], className)}
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.29287 6.70711C3.90237 6.31658 3.90237 5.68342 4.29287 5.29289C4.68338 4.90237 5.31657 4.90237 5.70707 5.29289L10.7071 10.2929C11.0976 10.6834 11.0976 11.3166 10.7071 11.7071L5.70707 16.7071C5.31657 17.0976 4.68338 17.0976 4.29287 16.7071C3.90237 16.3166 3.90237 15.6834 4.29287 15.2929L8.58577 11L4.29287 6.70711Z"
      fill="currentColor"
    />
    <path
      d="M19.7071 6.70711C20.0976 6.31658 20.0976 5.68342 19.7071 5.29289C19.3166 4.90237 18.6834 4.90237 18.2929 5.29289L13.2929 10.2929C12.9024 10.6834 12.9024 11.3166 13.2929 11.7071L18.2929 16.7071C18.6834 17.0976 19.3166 17.0976 19.7071 16.7071C20.0976 16.3166 20.0976 15.6834 19.7071 15.2929L15.4142 11L19.7071 6.70711Z"
      fill="currentColor"
    />
  </svg>
);

LeftRightExpandedIcon.propTypes = {
  ...sizePropsTypes,
  orientation: PropTypes.oneOf(Object.keys(orientationEnum)),
  className: PropTypes.string,
};

export default memo(LeftRightExpandedIcon);
